import { SnackbarMessage, OptionsObject } from 'notistack';

import {
  ENQUEUE_SNACKBAR,
  CLOSE_SNACKBAR,
  REMOVE_SNACKBAR,
  NotificationActions,
} from 'actions/notificationActions';

export type Notification = {
  message: SnackbarMessage;
  key: number | string;
  options?: OptionsObject;
  dismissed?: boolean;
};

export interface NotificationState {
  notifications: Notification[];
}

const initialState: NotificationState = {
  notifications: [],
};

export function notificationReducer(
  state = initialState,
  action: NotificationActions,
): NotificationState {
  switch (action.type) {
    case ENQUEUE_SNACKBAR:
      return {
        ...state,
        notifications: [...state.notifications, action.notification],
      };

    case CLOSE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.map((notification) =>
          action.dismissAll || notification.key === action.key
            ? { ...notification, dismissed: true }
            : { ...notification },
        ),
      };

    case REMOVE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.key !== action.key,
        ),
      };

    default:
      return state;
  }
}
